module.exports = __webpack_public_path__ + "img/wg.2d80f76b.jpg";